import {WorkrequestViewmodelBase} from '../../shared/viewmodels/workrequest-viewmodel-base';
import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestUsrViewmodel extends WorkrequestViewmodelBase {
  workrequestDetails: WorkrequestDetailsBase;
  invalidSelectionError: string;
  invalidDivewayError: string;
  errorMessage: string;

  constructor() {
    super();
    this.workrequestDetails = new WorkrequestDetailsBase();
    this.invalidSelectionError = 'Please select at least one work request option';
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/usr-form/workrequest-usr-viewmodel.ts